// extracted by mini-css-extract-plugin
export default {"regular":"CancelButton_regular__bLo1i"};